/**
 * SendLogDetailPage — 网关发送日志详情（只读）
 * 发送日志不可编辑/删除，仅展示完整信息。
 */
import { useParams, useLocation } from 'react-router-dom'
import {
  Badge,
} from '@fluentui/react-components'
import { PersonRegular } from '@fluentui/react-icons'
import { sendLogsApi } from '@/api/sendlogs'
import type { SendLog } from '@/api/types'
import DetailLayout, { DetailSection, DetailRow } from '@/components/DetailLayout'
import { useDetailItem } from '@/hooks/useDetailItem'
import { formatDate } from '@/lib/format'

const STATUS: Record<string, { color: 'brand' | 'success' | 'danger' | 'subtle'; label: string }> = {
  queued: { color: 'brand', label: '已入队' },
  sent: { color: 'success', label: '已发送' },
  failed: { color: 'danger', label: '失败' },
}

export default function SendLogDetailPage() {
  const { id } = useParams()
  const location = useLocation()

  const { item, isLoading } = useDetailItem<SendLog>(
    ['send-logs', 0],
    () => sendLogsApi.list(),
    id as string,
    'id',
  )

  const stateItem = (location.state as { item?: SendLog } | null)?.item

  return (
    <DetailLayout
      title={item?.subject ?? stateItem?.subject ?? item?.recipient ?? stateItem?.recipient ?? '发送日志'}
      subtitle="网关发送日志"
      media={<PersonRegular fontSize={22} />}
      badge={
        <Badge appearance="filled" color={STATUS[(item ?? stateItem)?.status ?? '']?.color ?? 'subtle'}>
          {STATUS[(item ?? stateItem)?.status ?? '']?.label ?? (item ?? stateItem)?.status}
        </Badge>
      }
      loading={isLoading && !stateItem}
      notFound={!isLoading && !item && !stateItem}
      notFoundText="未找到该发送日志"
    >
      <DetailSection title="日志详情">
        <DetailRow label="ID" value={item?.id ?? stateItem?.id} />
        <DetailRow label="主题" value={item?.subject ?? stateItem?.subject} />
        <DetailRow label="收件人" value={item?.recipient ?? stateItem?.recipient} />
        <DetailRow label="发件人" value={item?.sender ?? stateItem?.sender} />
        <DetailRow label="接入应用" value={item?.client_name ?? stateItem?.client_name} />
        <DetailRow
          label="状态"
          value={STATUS[(item ?? stateItem)?.status ?? '']?.label ?? (item ?? stateItem)?.status}
        />
        <DetailRow label="错误信息" value={item?.error ?? stateItem?.error} full />
        <DetailRow label="时间" value={formatDate((item ?? stateItem)?.created_at)} />
      </DetailSection>
    </DetailLayout>
  )
}
